module.exports = __webpack_public_path__ + "img/ukraine.730e1f84.png";